<template>
  <generic-modal :title="$t('log')" ref="generic_modal">
    <!-- <pre>{{ log }}</pre> -->
    <div class="timeline">
      <header class="timeline-header">
        <span class="tag is-medium is-primary">{{ $t("start") }}</span>
      </header>
      <div class="timeline-item pb-1" v-for="(lg, lidx) in log" :key="lidx">
        <div class="timeline-marker"></div>
        <div class="timeline-content">
          <p class="heading">{{ format_date_time(lg.date) }}</p>
          <p>{{ lg.message }}</p>
        </div>
      </div>
      <!-- <div class="timeline-header">
        <span class="tag is-medium is-primary">End</span>
      </div> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  generate_error_message_text,
  get,
  format_date_time,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import "bulma-extensions/bulma-timeline/dist/css/bulma-timeline.min.css";

export default {
  name: "OnfidoRequestLogModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      log: [],
      error: "",
    };
  },
  computed: {},
  methods: {
    format_date_time,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.$root.loader(true);
      get("/onfido/request/log", { uuid: uuid })
        .then((res) => {
          v.log = res;
        })
        .catch((err) => {
          v.error = generate_error_message_text(err);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.log = [];
      v.error = "";
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
